<script>
  import { Button } from '@shared/ui/buttons/button';
  import { Icon } from '@shared/ui/icon';

  import { purchaseRequestModel, requestAccordionActivity } from '../models';
  import { PurchaseRequestState } from '../types';
</script>

<section>
  <Icon name="successMark" classes="mb-5" />

  <p class="mb-5 text-2xl font-medium">Your request to purchase has been successfully saved.</p>

  <p class="mb-5">We appreciate your interest. We will get back to you shortly.</p>

  <Button
    on:click="{() => {
      requestAccordionActivity.toggle();
      purchaseRequestModel.set(PurchaseRequestState.Default);
    }}"
  >
    Close
  </Button>
</section>
